import axios from "axios"

export const REACT_APP_WORKER_BASE_URL = process.env.REACT_APP_WORKER_BASE_URL
export const API_ACCESS_KEY = process.env.REACT_APP_API_ACCESS_KEY ?? ""

export const NewsletterOfferWorkerClient = axios.create({
  baseURL: REACT_APP_WORKER_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Access-Key": API_ACCESS_KEY,
  },
})

NewsletterOfferWorkerClient.interceptors.request.use(config => {
  const key = process.env.REACT_APP_NEWSLETTER_OFFER_BROADCAST_API_KEY
  config.headers!["X-Access-Key"] = API_ACCESS_KEY

  if (key && config.headers) {
    config.headers["X-Api-Key"] = key
  }
  return config
})

NewsletterOfferWorkerClient.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
)
